class PredictiveSearch extends SearchForm {
    constructor() {
        super();
        this.cachedResults = {};
        this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
        this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
        this.isOpen = false;
        this.abortController = new AbortController();
        this.searchTerm = '';

        this.setupEventListeners();
    }

    setupEventListeners() {
        this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyup.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
        this.querySelector('.predictive-search__close')?.addEventListener('click', this.close.bind(this));
    }

    getQuery() {
        return this.input.value.trim();
    }

    onChange() {
        super.onChange();
        const newSearchTerm = this.getQuery();

        if (!newSearchTerm.length) {
            this.renderCategories();
            return;
        }

        if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
            this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
        }

        this.updateSearchForTerm(this.searchTerm, newSearchTerm);
        this.searchTerm = newSearchTerm;
        this.getSearchResults(this.searchTerm);
    }

    onFormSubmit(event) {
        if (!this.getQuery().length) {
            event.preventDefault();
            return;
        }
        
        if (this.querySelector('[aria-selected="true"]')) {
            return;
        }
        
        event.preventDefault();
        setTimeout(() => {
            this.input.form.submit();
        }, 10);
    }

    onFormReset(event) {
        super.onFormReset(event);
        if (super.shouldResetForm()) {
            this.searchTerm = '';
            this.abortController.abort();
            this.abortController = new AbortController();
            this.closeResults(true);
        }
    }

    onFocus() {
        const currentSearchTerm = this.getQuery();

        if (!currentSearchTerm.length) {
            this.renderCategories();
            return;
        }

        if (this.searchTerm !== currentSearchTerm) {
            this.onChange();
        } else if (this.getAttribute('results') === 'true') {
            this.open();
        } else {
            this.getSearchResults(this.searchTerm);
        }
    }

    onFocusOut() {
        if (!this.getQuery().length) return;
        
        setTimeout(() => {
            if (!this.contains(document.activeElement)) {
                this.close();
            }
        });
    }

    onKeyup(event) {
        if (!this.getQuery().length) {
            if (!this.isOpen) this.renderCategories();
            return;
        }

        switch (event.code) {
            case 'ArrowUp':
                this.switchOption('up');
                break;
            case 'ArrowDown':
                this.switchOption('down');
                break;
            case 'Enter':
                event.preventDefault();
                event.stopPropagation();
                setTimeout(() => {
                    this.input.form.submit();
                }, 10);
                break;
            case 'Escape':
                this.close();
                break;
        }
    }

    onKeydown(event) {
        if (event.code === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    renderCategories() {
        const searchTerms = [];
        for (let i = 1; i <= 6; i++) {
            const term = window.theme?.settings?.[`search_term_${i}`];
            if (term) {
                searchTerms.push(term);
            }
        }

        const categories = [];
        for (let i = 1; i <= 5; i++) {
            const category = window.theme?.categoryData?.[`category_${i}`];
            if (category) {
                categories.push(category);
            }
        }

        let html = `
            <div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper">
          <button class="predictive-search__close" aria-label="${this.getAttribute('data-close-text') || 'Fechar busca'}">
                    <svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 13L13 1M1 1L13 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="predictive-search__result-group">
                    <div>
                        <h2 id="predictive-search-terms" class="predictive-search__heading text-body caption-with-letter-spacing">
                            TERMOS MAIS PROCURADOS
                        </h2>
                        <ul
                            id="predictive-search-results-terms-list"
                            class="predictive-search__results-list list-unstyled"
                            role="group"
                            aria-labelledby="predictive-search-terms"
                        >
                          <li
      id="predictive-search-option"
      class="predictive-search__list-item"
      role="option"
      aria-selected="false"
    >
      Lixeiras
    </li>
    <li
      id="predictive-search-option"
      class="predictive-search__list-item"
      role="option"
      aria-selected="false"
    >
      Bambu
    </li>
    <li
      id="predictive-search-option"
      class="predictive-search__list-item"
      role="option"
      aria-selected="false"
    >
      Pote hermético
    </li>
    <li
      id="predictive-search-option"
      class="predictive-search__list-item"
      role="option"
      aria-selected="false"
    >
      Organização
    </li>
    <li
      id="predictive-search-option"
      class="predictive-search__list-item"
      role="option"
      aria-selected="false"
    >
      Banheiro
    </li>
    <li
      id="predictive-search-option"
      class="predictive-search__list-item"
      role="option"
      aria-selected="false"
    >
      Cesto roupa
    </li>
                        </ul>
                    </div>
                </div>
                <div class="predictive-search__result-group">
                    <div>
                        <h2 id="predictive-search-categories" class="predictive-search__heading text-body caption-with-letter-spacing">
                            CATEGORIAS EM ALTA
                        </h2>
                        <div class="predictive-search__products-grid">
        `;

        categories.forEach((category, index) => {
            html += `
                <div class="predictive-search__product-card">
                    <a href="${category.url}" class="predictive-search__item link link--text" tabindex="-1">
                        ${category.image ? `
                            <div class="card-image">
                                <img src="${category.image}" alt="${category.title}" loading="lazy">
                            </div>
                        ` : ''}
                        <div class="predictive-search__item-content predictive-search__item-content--centered">
                            <p class="predictive-search__item-heading h5">${category.title} 
                            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.90561 4.99261C3.97094 5.05901 4.0228 5.138 4.05819 5.22504C4.09358 5.31208 4.1118 5.40543 4.1118 5.49972C4.1118 5.59401 4.09358 5.68737 4.05819 5.77441C4.0228 5.86144 3.97094 5.94044 3.90561 6.00684L0.706184 9.27808C0.640851 9.34447 0.588995 9.42347 0.553607 9.51051C0.518219 9.59755 0.5 9.6909 0.5 9.78519C0.5 9.87948 0.518219 9.97283 0.553607 10.0599C0.588995 10.1469 0.640851 10.2259 0.706184 10.2923C0.836784 10.4253 1.01345 10.5 1.1976 10.5C1.38175 10.5 1.55842 10.4253 1.68901 10.2923L4.88844 7.01392C5.28004 6.61216 5.5 6.06755 5.5 5.49972C5.5 4.9319 5.28004 4.38729 4.88844 3.98552L1.68901 0.707144C1.55918 0.575192 1.38395 0.500801 1.20108 0.500013C1.10935 0.499469 1.01841 0.517485 0.933485 0.553029C0.848559 0.588574 0.771316 0.640947 0.706184 0.707144C0.640851 0.773542 0.588995 0.852537 0.553607 0.939574C0.518219 1.02661 0.5 1.11997 0.5 1.21426C0.5 1.30855 0.518219 1.4019 0.553607 1.48894C0.588995 1.57598 0.640851 1.65497 0.706184 1.72137L3.90561 4.99261Z" fill="#3E3E3D"/>
    </svg>
    </p>
                        </div>
                    </a>
                </div>
            `;
        });

        html += `
                        </div>
                    </div>
                </div>
            </div>
        `;

        this.predictiveSearchResults.innerHTML = html;
        
        this.querySelectorAll('#predictive-search-results-terms-list .predictive-search__list-item').forEach(item => {
            item.style.cursor = 'pointer';
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const term = item.textContent.trim();
                this.input.value = term;
                this.searchTerm = term;
                setTimeout(() => {
                    this.input.form.submit();
                }, 50);
            });
        });
        
        this.querySelector('.predictive-search__close')?.addEventListener('click', this.close.bind(this));
        
        this.setAttribute('results', true);
        this.open();
    }

    handleize(str) {
        return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    updateSearchForTerm(previousTerm, newTerm) {
        const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
        const currentButtonText = searchForTextElement?.innerText;
        if (currentButtonText) {
            if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
                return;
            }
            const newButtonText = currentButtonText.replace(previousTerm, newTerm);
            searchForTextElement.innerText = newButtonText;
        }
    }

    switchOption(direction) {
        if (!this.getAttribute('open')) return;

        const moveUp = direction === 'up';
        const selectedElement = this.querySelector('[aria-selected="true"]');

        const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
            (element) => element.offsetParent !== null
        );
        let activeElementIndex = 0;

        if (moveUp && !selectedElement) return;

        let selectedElementIndex = -1;
        let i = 0;

        while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
            if (allVisibleElements[i] === selectedElement) {
                selectedElementIndex = i;
            }
            i++;
        }

        this.statusElement.textContent = '';

        if (!moveUp && selectedElement) {
            activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
        } else if (moveUp) {
            activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
        }

        if (activeElementIndex === selectedElementIndex) return;

        const activeElement = allVisibleElements[activeElementIndex];

        activeElement.setAttribute('aria-selected', true);
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', activeElement.id);
    }

    selectOption() {
        const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

        if (selectedOption) selectedOption.click();
    }

    getSearchResults(searchTerm) {
  const queryKey = searchTerm.replace(' ', '-').toLowerCase();
  this.setLiveRegionLoadingState();

  if (this.cachedResults[queryKey]) {
    this.renderSearchResults(this.cachedResults[queryKey]);
    return;
  }

  const encodedTerm = encodeURIComponent(searchTerm);
  const url = `${routes.predictive_search_url}?q=${encodedTerm}&section_id=predictive-search&resources[options][fields]=title,product_type,variants.title,vendor,tag,variants.sku`;

  fetch(url, {
    signal: this.abortController.signal,
  })
    .then((response) => {
      if (!response.ok) {
        this.close();
        throw new Error(response.status);
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('#shopify-section-predictive-search').innerHTML;

      this.allPredictiveSearchInstances.forEach((instance) => {
        instance.cachedResults[queryKey] = resultsMarkup;
      });
      this.renderSearchResults(resultsMarkup);
    })
    .catch((error) => {
      if (error?.code === 20) return;
      this.close();
      throw error;
    });
}


    setLiveRegionLoadingState() {
        this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
        this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

        this.setLiveRegionText(this.loadingText);
        this.setAttribute('loading', true);
    }

    setLiveRegionText(statusText) {
        this.statusElement.setAttribute('aria-hidden', 'false');
        this.statusElement.textContent = statusText;

        setTimeout(() => {
            this.statusElement.setAttribute('aria-hidden', 'true');
        }, 1000);
    }

    renderSearchResults(resultsMarkup) {
        const closeButton = `
           <button class="predictive-search__close" aria-label="${this.getAttribute('data-close-text') || 'Fechar busca'}">
                <svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 13L13 1M1 1L13 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </button>
        `;
        
        this.predictiveSearchResults.innerHTML = closeButton + resultsMarkup;
        this.querySelector('.predictive-search__close')?.addEventListener('click', this.close.bind(this));
        this.setAttribute('results', true);
        this.setLiveRegionResults();
        this.open();
    }

    setLiveRegionResults() {
        this.removeAttribute('loading');
        this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }

    getResultsMaxHeight() {
        this.resultsMaxHeight =
            window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
        return this.resultsMaxHeight;
    }

    open() {
        this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
        this.setAttribute('open', true);
        this.input.setAttribute('aria-expanded', true);
        this.isOpen = true;
    }

    close(clearSearchTerm = false) {
        if (!this.getQuery().length && !clearSearchTerm) {
            return;
        }
        
        this.closeResults(clearSearchTerm);
        this.isOpen = false;
    }

    closeResults(clearSearchTerm = false) {
        if (clearSearchTerm) {
            this.input.value = '';
            this.removeAttribute('results');
        }
        const selected = this.querySelector('[aria-selected="true"]');

        if (selected) selected.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', '');
        this.removeAttribute('loading');
        this.removeAttribute('open');
        this.input.setAttribute('aria-expanded', false);
        this.resultsMaxHeight = false;
        this.predictiveSearchResults.removeAttribute('style');
    }
}

customElements.define('predictive-search', PredictiveSearch);